import { SceneContainer } from "GameObjects/StoryGame/SceneContainer";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Elastic, Expo, TimelineLite, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import {list} from "Utils/Reflection";

import {hh_ch1_72dpi_p030405} from "../../../layouts/ch1_p03-04-05/hh_ch1_72dpi_p03-04-05";

export class Chapter1Page3 extends AbstractStoryState {

	readonly background = this.addChild(new SceneSprite());
	readonly bedBottom = this.addChild(new SceneSprite());
	readonly hollyBase =  this.addChild(new SceneSprite());
	readonly face = list(() => this.addChildAt(new SceneSprite(), 3));
	readonly bedTop = this.addChild(new SceneSprite());
	readonly ambience = list(() => this.addChildAt(new SceneSprite(), 7));
	readonly light = this.addChild(new SceneSprite());
	readonly frame = list(() => this.addChildAt(new SceneSprite(), 10));

	dontScaleUp = true;

    public init(pSize: PIXI.Point, pData: any) {
		// exported layout from Animate CC
		hh_ch1_72dpi_p030405.call(this);
		this.frameLeft = this.frame[1];
		this.frameRight = this.frame[0];

		// initial state
		this.face[0].visible = true;
		this.face[1].visible = false;
		this.face[2].visible = false;

		// super.init calls onResize
		super.init(pSize, pData);
	}

	public animateIn(pOnComplete: ()=>void) {
		super.animateIn(pOnComplete);
	}

	protected onAnimateInComplete() {
		new TimelineLite()
			.to(this.ambience, 1, {pixi: {alpha: 0}}, 0)
			.call(()=>{
				this.face[0].visible = false;
				this.face[1].visible = true;
			}, undefined, undefined, 1.75)
			.call(()=>{
				this.face[1].visible = false;
				this.face[2].visible = true;
				super.onAnimateInComplete();
			}, undefined, undefined, 2.75)
			.call(()=>{
				this.gotoNextState({transition: "up"});
			}, undefined, undefined, "+=1.5");
	}
}